
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wydarzenia",
      function () {
        return require("private-next-pages/wydarzenia/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wydarzenia"])
      });
    }
  